import { FooterType, LogoType, type PlatformConfiguration } from "../../types/PlatformConfiguration";

export default {
  "platformId": "43bc8ad4-6edf-4313-bd55-60f194de15c5",
  "platformName": "MatchWornShirt",
  "configurationId": "50b1f66e-d4e7-40b1-8901-88825eeb4444",
  "configurationName": "MatchWornShirt default configuration",
  "primaryDomain": "mws.com",
  "isAuctionsEnabled": true,
  "isFabricksEnabled": false,
  "onlyAutomaticallyPublishFixtureEvents": false,
  "configurationDefaultHead": {
    "meta": {
      "description": "Platform description"
    }
  },
  "tracking": {
    "isEnabled": false,
    "segmentWriteKey": "",
    "ga4MeasurementId": ""
  },
  "properties": {
    "referencesMatchWornShirt": false,
    "isFrameTheGameOfficialPartner": false,
    "isCategorySearchEnabled": true,
    "availableLanguages": [
      {
        "isoLanguageCode": "en"
      },
      {
        "isoLanguageCode": "nl"
      },
      {
        "isoLanguageCode": "de"
      },
      {
        "isoLanguageCode": "es"
      },
      {
        "isoLanguageCode": "zh"
      },
      {
        "isoLanguageCode": "ja"
      }
    ],
    "defaultLanguage": {
      "isoLanguageCode": "en"
    },
    "defaultCurrency": {
      "name": "Euro",
      "isoCurrencyCode": "EUR",
      "symbol": "€"
    },
    "availableCurrencies": [
      {
        "name": "Euro",
        "isoCurrencyCode": "EUR",
        "symbol": "€"
      },
      {
        "name": "Dollar",
        "isoCurrencyCode": "USD",
        "symbol": "$"
      },
      {
        "name": "Pound Sterling",
        "isoCurrencyCode": "GBP",
        "symbol": "£"
      },
      {
        "name": "Chinese Yuan",
        "isoCurrencyCode": "CNY",
        "symbol": "¥"
      },
      {
        "name": "Japanese Yen",
        "isoCurrencyCode": "JPY",
        "symbol": "¥"
      },
      {
        "name": "Turkish Lira",
        "isoCurrencyCode": "TRY",
        "symbol": "₺"
      }
    ],
    "featureFlags": {
      "customerPreferences": true,
      "nitroStoryblokEndpoint": true
    },
  },
  "styling": {
    "theme": {
      "text-1": "#000000",
      "text-2": "#919191",
      "text-3": "#000000",
      "background-1": "#FFFFFF",
      "background-2": "#F3F4F6",
      "background-3": "#878787",
      "border-1": "#EBEBEB",
      "border-2": "#242424",
      "color-1": "#000000",
      "color-2": "#ffffff",
      "color-3": "#000000",
      "color-4": "#000000",
      "neutral": "#0D99FF",
      "overlay-1": "#DB0021",
      "success": "#3caf28",
      "danger": "#d70828",
      "warning": "#ffd700"
    },
    "fonts": [
      {
        "url": "/fonts/mwsDefaultFontRegular.woff2",
        "weight": "normal"
      },
      {
        "url": "/fonts/mwsDefaultFontBold.woff2",
        "weight": "bold"
      }
    ]
  },
  "assets": {
    "primaryLogo": "https://matchwornshirt.imgix.net/assets/MWS_Logo_Wordmark_Master_Black.svg",
    "secondaryLogo": "https://matchwornshirt.imgix.net/assets/MWS_Logo_Wordmark_Master_White.svg",
    "lightModeLogo": "https://matchwornshirt.imgix.net/assets/MWS_Logo_Wordmark_Master_Black.svg",
    "favIconUrl": "",
  },
  "header": {
    "properties": {
      "productAuthenticationActive": true,
      "logo": LogoType.PrimaryLogo,
    }
  },
  "footer": {
    "type": FooterType.MwsFooter,
    "properties": {
      "supportEmail": "support@matchwornshirt.inbox.ai",
      "isSubfooterShown": true,
      "availableSocials": [
        {
          "name": "facebook",
          "imageUri": "",
          "qrCodeUri": "",
          "link": "https://www.facebook.com/matchwornshirt.official"
        },
        {
          "name": "twitter",
          "imageUri": "",
          "qrCodeUri": "",
          "link": "https://twitter.com/matchwornshirt"
        },
        {
          "name": "instagram",
          "imageUri": "",
          "qrCodeUri": "",
          "link": "https://www.instagram.com/matchwornshirt.official/"
        },
        {
          "name": "youtube",
          "imageUri": "",
          "qrCodeUri": "",
          "link": "https://www.youtube.com/channel/UCbq1BRqTE7Ewobb0mbhNk7g?view_as=subscriber"
        },
        {
          "name": "weibo",
          "imageUri": "",
          "qrCodeUri": "",
          "link": "https://weibo.com/u/7422021540"
        },
        {
          "name": "wechat",
          "imageUri": "",
          "qrCodeUri": "https://www.mws.com/en-US/assets/images/qr.jpg",
          "link": ""
        }
      ],
      "paymentOptions": [
        {
          "name": "visa",
          "imageUri": ""
        },
        {
          "name": "mastercard",
          "imageUri": ""
        },
        {
          "name": "paypal",
          "imageUri": ""
        },
        {
          "name": "alipay",
          "imageUri": ""
        },
        {
          "name": "klarna",
          "imageUri": ""
        }
      ],
      "logo": LogoType.SecondaryLogo,
      "styling": {
        "usesGlobalTheme": true,
        "theme": null
      },
      "newsletterOptions": {
        "enabled": false,
        "theme": null
      }
    }
  },
} satisfies PlatformConfiguration